<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12C8.20063 12 9.30243 11.5768 10.1644 10.8715L13.182 13.8891C13.3772 14.0843 13.6938 14.0843 13.8891 13.8891C14.0843 13.6938 14.0843 13.3772 13.8891 13.182L10.8715 10.1644C11.5768 9.30243 12 8.20063 12 7C12 4.23858 9.76142 2 7 2ZM3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7Z"
    fill="currentColor" />
</template>
